/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable comma-spacing */
/* eslint-disable no-multi-spaces */
/* eslint-disable react/no-multi-comp */
import 'react-datepicker/dist/react-datepicker.css';
import React, { useEffect, useState, useReducer } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { isFunction } from 'lodash';
import { Alert, Form, Button, DatePicker, FormControl } from 'rsuite';
// material-ui
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import BusinessIcon from '@material-ui/icons/Business';
// components
import { ButtonIcon, ColumnStatus, WidgetAccount, WidgetDate, WidgetTitleSubtitle } from '../components/index.js';
import { Table } from '../components/table/Table.js';
import DialogCommerceCreate from '../components/dialog/DialogCommerceCreate.js';
import DialogCommerceUpdate from '../components/dialog/DialogCommerceUpdate.js';
import DialogSellerCreate from '../components/dialog/DialogSellerCreate.js';
import FilterQueryParams from '../components/FilterQueryParams.js';
import Tabs from '../components/Tabs.js';
// constants
import statuses from '../constants/commerce/status.js';
import allRoles from '../constants/roles/roles.js';
// helpers
import { dateFns } from '../components/DateFnsUtils.js';
import validator from '../helpers/validator.js';
// services
import { cuotitasStoreService } from '../services/index.js';

function ColumnNameFormatter (cellContent) {
    return (
        <WidgetTitleSubtitle
            title={(<WidgetAccount account={[cellContent]} />)}
        />
    );
}

function ColumnDateFormatter (cellContent) {
    return (
        <WidgetDate date={new Date(cellContent)} />
    );
}

function ColumnStatusFormatter (cellContent) {
    return (
        <ColumnStatus { ...statuses[cellContent] } />
    );
}

function ColumnActionsFormatter (cellContent, row, rowIndex, { dialogCommerceUpdateOpen }) {
    return (
        <div>
            <ButtonIcon
                title='Ver Empresa'
                size='small'
                icon={(<BusinessIcon className='svg-icon' />)}
                onClick={() => dialogCommerceUpdateOpen(row.id)}
            />
            <ButtonIcon
                title='Ver vendedores'
                size='small'
                icon={(<Link to={`/commerce/${row.id}/sellers`}>
                    <BusinessCenterIcon className='svg-icon' />
                </Link>)}
            />
        </div>
    );
}

export function Commerce ({ user }) {
    // data

    const tabs = [
        { id: 2, name: 'success', label: 'Exitosos' },
        { id: 1, name: 'pending', label: 'Pendientes' },
        { id: 3, name: 'deleted', label: 'Anulados' },
    ];

    const columns = [
        { dataField: 'id'              , text: 'ID'                 , sort: false },
        { dataField: 'name'            , text: 'Nombre'             , sort: false, align: 'left', formatter: ColumnNameFormatter },
        { dataField: 'cuit'            , text: 'CUIT'               , sort: false, align: 'left', headerAlign: 'left' },
        { dataField: 'business_unit'   , text: 'Unidad de Negocios' , sort: false, align: 'left', headerAlign: 'left' },
        { dataField: 'created_at'      , text: 'Fecha'              , sort: false, formatter: ColumnDateFormatter },
        { dataField: 'id_store_status' , text: 'Estado'             , sort: false, align: 'left', headerAlign: 'left', formatter: ColumnStatusFormatter },
        { dataField: 'person.id'       , text: 'Acciones'           , sort: false, align: 'center', headerAlign: 'center', formatExtraData: { dialogCommerceUpdateOpen }, formatter: ColumnActionsFormatter }
    ];

    const roles = user?.roles;

    // state

    const [isLoading, setIsLoading] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);

    const [tab, setTab] = useState(tabs[0]);
    const [search, setSearch] = useState('');
    const [date, setDate] = useState(null);

    const [storeList, setStoreList] = useState([]);
    const [storeSelectedId, setStoreSelectedId] = useState();

    const [query, setQuery] = useReducer((oldQuery, newQuery) => {
        if (isFunction(newQuery)) {
            return newQuery(oldQuery);
        }
        return newQuery;
    }, {
        sortOrder: 'desc',
        sortField: 'created_at',
        pageNumber: 1,
        pageSize: 10
    });

    // actions

    async function filter () {
        try {
            setIsLoading(true);

            const filters = new FilterQueryParams();

            const { sortField, sortOrder } = query;

            const options = {
                order: `${sortField}-${sortOrder.toUpperCase()}`,
                pageSize: query.pageSize,
                page: query.pageNumber,
            };

            filters.equal('id_store_status', tab.id);

            if (date) {
                const startAt = dateFns.parse(dateFns.format(date, 'y-MM-dd 00:00:00'), 'y-MM-dd HH:mm:ss');
                const startTo = dateFns.parse(dateFns.format(date - 1, 'y-MM-dd 00:00:00'), 'y-MM-dd HH:mm:ss');

                filters.between(
                    'created_at',
                    dateFns.format(startTo, 'y-MM-dd 00:00:00'),
                    dateFns.format(startAt, 'y-MM-dd 23:59:59')
                );
            }

            if (search.length > 0 && validator.isInteger(search)) {
                filters.like('cuit', `*${search}*`);
            }

            if (search.length > 0 && !validator.isInteger(search)) {
                filters.like('name', `*${search}*`);
            }

            options.filters = filters.build();

            const stores = await cuotitasStoreService.find(options);

            setStoreList(stores);

            return stores;
        }
        catch (error) {
            console.error(error);
            Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
        }
        finally {
            setIsLoading(false);
        }
    };

    // dialog commerce creation

    const [dialogCommerceCreateIsOpen, setDialogCommerceCreateIsOpen] = useState(false);

    function dialogCommerceCreateOpen () {
        setDialogCommerceCreateIsOpen(true);
    };

    function dialogCommerceCreateClose () {
        setDialogCommerceCreateIsOpen(false);
        filter();
    };

    // dialog seller creation

    const [dialogSellerCreateIsOpen, setDialogSellerCreateIsOpen] = useState(false);

    function dialogSellerCreateOpen () {
        setDialogSellerCreateIsOpen(true);
    };

    function dialogSellerCreateClose () {
        setDialogSellerCreateIsOpen(false);
        filter();
    };

    // dialog commerce update

    const [dialogCommerceUpdateIsOpen, setDialogCommerceUpdateIsOpen] = useState(false);

    function dialogCommerceUpdateOpen (id) {
        setStoreSelectedId(id);
        setDialogCommerceUpdateIsOpen(true);
    };

    function dialogCommerceUpdateClose () {
        setStoreSelectedId(0);
        setDialogCommerceUpdateIsOpen(false);
        filter();
    };

    // effects

    useEffect(() => {
        filter();
    }, [tab, query, date]);

    useEffect(() => {
        setQuery({ ...query, pageNumber: 1 });
    }, [tab]);

    useEffect(() => {
        if (search === '') {
            filter();
        }
    }, [search]);

    useEffect(() => {
        for (const role of roles) {
            if (role.role.id === allRoles['admin.cuotitas']) {
                setIsAdmin(true);
                break;
            }
        }
    }, []);

    return (
        <main className='page'>
            <h1 className="page-header">
                Comercios
            </h1>
            <div className="page-filters">
                <Tabs
                    className="page-filters-tabs"
                    items={tabs}
                    selected={tab}
                    onSelect={setTab}
                />
                <div className="page-filters-toolbar">
                    <Form id="form-toolbar" className="page-filters-form" onSubmit={filter}>
                        <FormControl
                            placeholder="Buscar por nombre o CUIT"
                            appearance='subtle'
                            style={{ width: 300 }}
                            value={search}
                            onChange={setSearch}
                        />
                        <DatePicker
                            block
                            oneTap
                            style={{ width: 150 }}
                            size='md'
                            placeholder='Fecha de Alta'
                            limitEndYear={2020}
                            renderValue={(value, format) => `${dateFns.format(value, 'dd/MM/y')}`}
                            onChange={setDate}
                            onClean={() => setDate(null)}
                        />
                    </Form>
                    <div className="page-filters-actions">
                        <Button type="submit" form="form-toolbar" appearance='primary' loading={isLoading}>
                            Buscar
                        </Button>
                        {isAdmin && <Button appearance='primary' onClick={dialogCommerceCreateOpen} disabled={isLoading}>
                            Cargar Comercio
                        </Button>}
                        {isAdmin && <Button appearance='primary' onClick={dialogSellerCreateOpen} disabled={isLoading}>
                            Crear usuario vendedor
                        </Button>}
                    </div>
                </div>
            </div>
            <div className="page-content">
                <Table
                    data={storeList}
                    columns={columns}
                    onChange={setQuery}
                    isLoading={isLoading}
                    pagination={{
                        sizePerPage: query.pageSize,
                        page: query.pageNumber,
                    }}
                />
            </div>
            {dialogCommerceCreateIsOpen && <DialogCommerceCreate
                show={dialogCommerceCreateIsOpen}
                onHide={dialogCommerceCreateClose}
            />}
            {dialogCommerceUpdateIsOpen && <DialogCommerceUpdate
                show={dialogCommerceUpdateIsOpen}
                onHide={dialogCommerceUpdateClose}
                id={storeSelectedId}
            />}
            {dialogSellerCreateIsOpen && <DialogSellerCreate
                show={dialogSellerCreateIsOpen}
                onHide={dialogSellerCreateClose}
            />}
        </main>
    );
}

export default connect(({ auth: { user } }) => ({ user }))(Commerce);
